export default __webpack_public_path__ + "static/media/building-icon.ba15730a.svg";